










import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AppButtonAddLicense extends Vue {
  onAddEmail() {
    this.$store.commit("ADD_LICENSE_CLICK");
  }
}
